//本地地缓存工具，用于 Token 等数据的存储和读取。
import Cookies from 'js-cookie'

const TokenKey = 'vue_admin'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}
